import Icon from 'components/ui/Icon';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import styles from './Checklist.module.scss';
import type { IBlockChecklistFields } from 'types/contentful/generated/index';

const Checklist = ({
  blockId,
  headline,
  items,
}: IBlockChecklistFields): JSX.Element => (
  <div id={sanitizeContentfulBlockId(blockId)} className={styles.container}>
    <div className={styles.wrapper}>
      <p className={styles.headline}>{headline}</p>
      {items && (
        <ul className={styles.list}>
          {items.map((item, i: number) => (
            <li key={i} className={styles.listItem}>
              <p className={styles.item}>
                <Icon
                  className={styles.icon}
                  type="RoundCheck"
                  color="#ffca58"
                />
                {item}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

export default Checklist;
